import React from 'react';

import { Button } from 'semantic-ui-react';

const DeleteModifier = ({ onClick }) => <Button icon="delete" onClick={onClick} />;

export default DeleteModifier;
